module.exports = __webpack_public_path__ + "static/media/vote-form-title-red.239b1c78.svg";